export default function ComingSoonTab({ tabName }) {
  return (
    <div className="flex items-center justify-center py-32">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/[0.03] border border-white/[0.06] mb-5">
          <span className="text-white/30 text-2xl font-light">$</span>
        </div>
        <h2 className="text-xl font-light text-white/70 mb-2">{tabName}</h2>
        <p className="text-white/30 text-sm max-w-sm">
          This module is coming in Phase 2. Connect QuickBooks and sync data to unlock full financial intelligence.
        </p>
      </div>
    </div>
  );
}
